'use client';

import React from 'react';
import { ArrowDown, Maximize, ArrowUp, Eye, Trash2 } from 'lucide-react';
import { InfoTooltip } from './InfoTooltip';
import Tooltip from './Tooltip';

export default function DropdownMenu({
    itemId,
    isOpen,
    onClose,
    canDelete,
    onDelete,
    // onRename,
    onMove,
    onPreview,
    onSampleContent,
    isSubsection = false // <--- Receive prop here
}) {
    if (!isOpen) return null;

    return (
        <div className="absolute right-0 mt-2 w-60 bg-white border border-lightGrey rounded shadow-lg z-10">
            {/* Delete button - only shown for added sections (canDelete: true) */}
            {canDelete && (
                <button
                    className="flex items-center gap-2 w-full px-4 py-2 text-base font-semibold text-red-600 hover:bg-red-50 text-left"
                    onClick={() => {
                        onDelete && onDelete(itemId);
                        onClose();
                    }}
                >
                    <Trash2 className="w-4 h-4 text-red-600" /> 
                    {isSubsection ? 'Delete Subsection' : 'Delete Section'}
                    <Tooltip placement="left" content={isSubsection ? "Remove this subsection" : "Remove this section"}>
                        <InfoTooltip />
                    </Tooltip>
                </button>
            )}
			{/* <button
				className="flex items-center gap-2 w-full px-4 py-2 text-base font-semibold text-dark-blue hover:bg-lightGrey/50 text-left"
				onClick={() => {
					onRename && onRename(itemId);
					onClose();
				}}
			>
				<Pencil className="w-4 h-4 text-dark-blue" /> Rename
				<Tooltip placement="left" content="Rename section">
					<InfoTooltip />
				</Tooltip>
			</button> */}
            
            <button
                className="flex items-center gap-2 w-full px-4 py-2 text-base font-semibold text-dark-blue hover:bg-lightGrey/50 text-left"
                onClick={() => {
                    onMove && onMove(itemId, 'up');
                    onClose();
                }}
            >
                <ArrowUp className="w-4 h-4 text-dark-blue" /> Move up
                <Tooltip placement="left" content="Move up">
                    <InfoTooltip />
                </Tooltip>
            </button>
            <button
                className="flex items-center gap-2 w-full px-4 py-2 text-base font-semibold text-dark-blue hover:bg-lightGrey/50 text-left"
                onClick={() => {
                    onMove && onMove(itemId, 'down');
                    onClose();
                }}
            >
                <ArrowDown className="w-4 h-4 text-dark-blue" /> Move down
                <Tooltip placement="left" content="Move down">
                    <InfoTooltip />
                </Tooltip>
            </button>
            <button
                className="flex items-center gap-2 w-full px-4 py-2 text-base font-semibold text-dark-blue hover:bg-lightGrey/50 text-left"
                onClick={() => {
                    onPreview && onPreview(itemId);
                    onClose();
                }}
            >
                <Maximize className="w-4 h-4 text-dark-blue" /> Full page preview
                <Tooltip placement="left" content="Preview">
                    <InfoTooltip />
                </Tooltip>
            </button>
            <button
                className="flex items-center gap-2 w-full px-4 py-2 text-base font-semibold text-dark-blue hover:bg-lightGrey/50 text-left"
                onClick={() => {
                    onSampleContent && onSampleContent(itemId);
                    onClose();
                }}
            >
                <Eye className="w-4 h-4 text-dark-blue" /> Sample Content
                <Tooltip placement="left" content="View sample content">
                    <InfoTooltip />
                </Tooltip>
            </button>
        </div>
    );
}